import { Box, Flex } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import CartFooter from 'src/components/CartFooter/CartFooter'
import UserTypePicker from 'src/components/UserTypePicker'
import useFiltersState from 'src/hooks/useFiltersState'
import useSearchState from 'src/hooks/useSearchState'
import { useCart, useProductCategories, useProducts } from 'src/services/api/queries/queries'
import ProductDetails from './components/ProductDetails'
import Filters from './components/ProductFilter'
import ProductSearchBar from './components/ProductSearchBar'

export type FilterState = {
  category: string[]
}

const defaultFilters = { category: [] }

export const ProductsPage: React.FC = () => {
  const { searchText, onSearchTextChange, debouncedSearch } = useSearchState(200)
  const { filterState, updateFilter } = useFiltersState<FilterState>(defaultFilters, defaultFilters)

  const {
    data: products,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
  } = useProducts({
    searchTerm: debouncedSearch,
    filters: filterState,
  })

  const { data: categories } = useProductCategories()
  const { data: cartItems } = useCart()

  const loadMore = () => {
    if (hasNextPage) {
      fetchNextPage()
    }
  }

  return (
    <Box px='24px' backgroundColor='gray.50' p={4}>
      <UserTypePicker />
      <ProductSearchBar searchText={searchText} onSearchTextChange={onSearchTextChange} />
      <Flex direction={{ base: 'column', md: 'row' }} mt={4}>
        <Filters categories={categories} filterState={filterState} updateFilter={updateFilter} />
        <ProductDetails
          debouncedSearch={debouncedSearch}
          products={products}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          loadMore={loadMore}
          status={status}
        />
      </Flex>

      {cartItems?.items_count > 0 && <CartFooter />}
    </Box>
  )
}

export default ProductsPage
